import { combineReducers } from 'redux'

import references from './refs'
import diseases from './diseases'

export default combineReducers({
  diseases,
  references
})

export * from './refs'
export * from './diseases'
